import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useProvider } from '../contexts/ProviderContext';
import SubmitEvent from './SubmitEvent';
import SignUpToSubmit from './SignUpToSubmit';

const Submit: React.FC = () => {
    const { currentUser } = useAuth();
    const { hasProvider, providerData, loading } = useProvider();

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!currentUser) {
        return <SignUpToSubmit />;
    }

    if (!hasProvider) {
        return <div>Please Register a Provider to Submit Events</div>;
    }

    if (!providerData?.approved) {
        return <div>Please wait for approval</div>;
    }

    return <SubmitEvent />;
};

export default Submit;